import { useCallback } from 'react';
import { carPermitsService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { CarCoastGuardPermit } from '../types';

export function useCarPermits(
  options?: ResourceQueryOptions
): ResourceState<CarCoastGuardPermit> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      carPermitsService.getAll(opts) as unknown as Promise<{ data: CarCoastGuardPermit[]; meta?: any }>,
    []
  );
  return useResourceCollection<CarCoastGuardPermit>(fetchFn, options);
}

export function useCarPermit(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<CarCoastGuardPermit> {
  const resourceId = id;
  const fetchFn = useCallback(
    (permitId: string | number, opts?: ResourceQueryOptions) =>
      carPermitsService.getById(permitId, opts) as unknown as Promise<CarCoastGuardPermit>,
    []
  );
  return useResourceById<CarCoastGuardPermit>(fetchFn, resourceId, options);
}

export function useCreateCarPermit(
  onSuccess?: (data: CarCoastGuardPermit) => void
): MutationState<CarCoastGuardPermit> {
  const createFn = useCallback(
    (data: any) => carPermitsService.create(data) as unknown as Promise<CarCoastGuardPermit>,
    []
  );
  return useCreateResource<CarCoastGuardPermit>(createFn, onSuccess);
}

export function useUpdateCarPermit(
  onSuccess?: (data: CarCoastGuardPermit) => void
): MutationState<CarCoastGuardPermit> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return carPermitsService.update(id, data) as unknown as Promise<CarCoastGuardPermit>;
    },
    []
  );
  return useUpdateResource<CarCoastGuardPermit>(updateFn, onSuccess);
}

export function useDeleteCarPermit(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return carPermitsService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}

